/// <reference path="../../../Modules/Attr/Dialog/NoboxEntityDialog.ts" />
namespace Nobox {

    @Serenity.Decorators.registerClass()
    export class ChatroomsFIlterDialog extends NoboxEntityDialog<ChatroomsFilterForm, any> {
        protected getFormKey() { return ChatroomsFilterForm.formKey; }

        protected form = new ChatroomsFilterForm(this.idPrefix);
        public callback = (response) => {

        }
        public isAgent: boolean;
        constructor(container?: JQuery) {
            super(container);
            var $this = this;
            var $form = this.form;
            var objFil = localStorage.getItem('filterConversation');
            if (this.isAgent == true) {
                objFil = localStorage.getItem('filterConversationAgent');
            }
            if (objFil) {
                var objFilter = JSON.parse(objFil);
                if (objFilter.ags != undefined) {
                    $form.Agent.set_value(objFilter.ags);
                }
                $form.Tags.set_value(objFilter.tags);
                $form.Funnel.set_value(objFilter.fn);
                $form.Channel.set_value(objFilter.chs);
                $form.Campaign.set_value(objFilter.cp);
                $form.Deal.set_value(objFilter.dl);
                if (objFilter.st != undefined) {
                    $form.St.set_value(objFilter.st);
                }
                $form.Account.set_value(objFilter.ac);
                $form.Contact.set_value(objFilter.ct);
                $form.Link.set_value(objFilter.lk);
                $form.Chat.set_value(objFilter.chat);
                $form.Group.set_value(objFilter.grp);
                //$form.Created.set_value(objFilter.sd);
                //$form.Created.end_set_value(Q.isEmptyOrNull(objFilter.ed) ? null : moment(objFilter.ed).add("days", -1).format("MM/DD/YYYY"));
            }
            $this.dialogTitle = "Filter Conversation";
        }
        
        filters() {
            var $form = this.form;
            var objFilter = {
                tags: $form.Tags.value,
                fn: $form.Funnel.value,
                chs: $form.Channel.value,
                cp: $form.Campaign.value,
                dl: $form.Deal.value,
                ac: $form.Account.value,
                ct: $form.Contact.value,
                lk: $form.Link.value,
                chat: $form.Chat.value,
                grp: $form.Group.value,
                //sd: Q.isEmptyOrNull(this.form.Created.get_value()) ? null : moment(this.form.Created.get_value()).format("MM/DD/YYYY"),
                //ed: Q.isEmptyOrNull(this.form.Created.end_get_value()) ? null : moment(this.form.Created.end_get_value()).format("MM/DD/YYYY"),
            } as any;
            
            localStorage.setItem('filterConversationAgent', JSON.stringify(objFilter));

            objFilter.st = $form.St.value;
            objFilter.ags = $form.Agent.value;
            localStorage.setItem('filterConversation', JSON.stringify(objFilter));
            this.callback(JSON.stringify(objFilter));
            this.dialogClose();
        }
        reset() {
            var $form = this.form;
            $form.Agent.set_value("");
            $form.Tags.set_value("");
            $form.Funnel.set_value("");
            $form.Channel.set_value("");
            $form.Campaign.set_value("");
            $form.Deal.set_value("");
            $form.St.set_value("");
            $form.Account.set_value("");
            $form.Contact.set_value("");
            $form.Link.set_value("");
            $form.Chat.set_value("");
            $form.Group.set_value("");
            //$form.Created.set_value(null);
            //$form.Created.end_set_value(null);
            localStorage.setItem('filterConversation', "");
            localStorage.setItem('filterConversationAgent', "");
        }
        protected getToolbarButtons() {
            var $this = this;
            var buttons = super.getToolbarButtons();
            buttons[0].hint = "Apply";
            buttons[0].cssClass = "btn-apply-filter";
            buttons[0].title = "Apply";
            buttons[0].icon = "fa-filter text-primary";
            buttons[0].onClick = function () {
                $this.filters();
            }
            buttons[1].hint = "Reset";
            buttons[1].cssClass = "btn-reset-filter";
            buttons[1].title = "Reset";
            buttons[1].icon = null;
            buttons[1].separator = true;
            buttons[1].onClick = function () {
                $this.reset();
            }

            buttons[2].visible = false;
            buttons[3].visible = false;
            buttons[4].visible = false;
            buttons[5].visible = false;
            return buttons;
        }
        dialogClose() {
            super.dialogClose();
        }
        dialogOpen() {
            super.dialogOpen();
            if (this.isAgent == true) {
                this.form.Agent.getGridField().toggle(false);
                this.form.St.getGridField().toggle(false);
            }
        }
    }
}